import { useCloseModal, useShowModal } from '@/atoms'

import { modalId } from './hooks/useController'
import { Root } from './components/Root'

export type { MoveOrdersPayload } from './typings'

export const useMoveOrdersModal = () => ({
  show: useShowModal(modalId),
  close: useCloseModal(),
  Modal: Root,
})
